import { useEffect, useState } from "react";

export default function QuizItem({ quiz, resultHandler }) {
	const { id, question, options } = quiz || {};

	const [option0, setOption0] = useState(false);
	const [option1, setOption1] = useState(false);
	const [option2, setOption2] = useState(false);
	const [option3, setOption3] = useState(false);

	useEffect(() => {
		if (
			option0 === options[0].isCorrect &&
			option1 === options[1].isCorrect &&
			option2 === options[2].isCorrect &&
			option3 === options[2].isCorrect
		) {
			resultHandler({ quizId: id, score: 5 });
		}
		else {
			resultHandler({ quizId: id, score: 0 });
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [option0, option1, option2, option3, options]);

	return (
		<div className="quiz">
			<h4 className="question">{question}</h4>
			<form className="quizOptions">
				{/* <!-- Option 1 --> */}
				<label htmlFor={`option1_q${id}`}>
					<input
						checked={option0}
						onChange={(e) => setOption0(!option0)}
						type="checkbox"
						id={`option1_q${id}`}
					/>
					{options[0].option}
				</label>

				{/* <!-- Option 2 --> */}
				<label htmlFor={`option2_q${id}`}>
					<input
						checked={option1}
						onChange={(e) => setOption1(!option1)}
						type="checkbox"
						id={`option2_q${id}`}
					/>
					{options[1].option}
				</label>

				{/* <!-- Option 3 --> */}
				<label htmlFor={`option3_q${id}`}>
					<input
						checked={option2}
						onChange={(e) => setOption2(!option2)}
						type="checkbox"
						id={`option3_q${id}`}
					/>
					{options[2].option}
				</label>

				{/* <!-- Option 4 --> */}
				<label htmlFor={`option4_q${id}`}>
					<input
						checked={option3}
						onChange={(e) => setOption3(!option3)}
						type="checkbox"
						id={`option4_q${id}`}
					/>
					{options[3].option}
				</label>
			</form>
		</div>
	);
}
